var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "fas fa-broadcast-tower" }
          }),
          _vm._v(" " + _vm._s(_vm.webcast.title) + "\n    ")
        ],
        1
      ),
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1",
          attrs: { color: "secondary" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _vm.showTab && _vm.show_stream
            ? _c("q-tab", {
                attrs: {
                  slot: "title",
                  name: "stream",
                  label: _vm.$t("stream")
                },
                slot: "title"
              })
            : _vm._e(),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTab && _vm.show_chat_moderation,
                expression: "showTab && show_chat_moderation"
              }
            ],
            attrs: {
              slot: "title",
              name: "chat_moderation",
              label: _vm.$t("chat_moderation")
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            {
              staticClass: "q-px-lg q-pb-xl",
              attrs: { name: "stream", "keep-alive": "" }
            },
            [_c("stream", { attrs: { id_webcast: _vm.webcast.id } })],
            1
          ),
          _c(
            "q-tab-pane",
            {
              staticClass: "q-px-lg q-pb-xl",
              attrs: { name: "chat_moderation" }
            },
            [
              _c("chat-moderation", {
                attrs: { id_webcast: _vm.webcast.id },
                on: { hideModal: _vm.hideModal }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }